// => Import React
import React from "react"

// => Import Plugin
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"
import { UUID } from "../utils/UUID.js"

// Component => 
const SEO = ({
  title, // Title of page (Site name, Categorie or Product)
  description, // product description
  images, // Product images
  product = false, // If product bool === true
  tags = null, // more tags if categories page
  price, // product price
  weight, // product weight
  updatedAt, // date update product
  publishedAt, // date published product
  noStock // boolean 
}) => {

  // current page 
  const { pathname } = useLocation()
  // query data
  const { site } = useStaticQuery(query)

  // Images Product form props
  let imagesProduct = null
  if (images && product) {
    imagesProduct = images.map((image) => image.url)
  }

  // => Default Metadata
  const {
    defaultTitle,
    defaultDescription,
    siteUrl,
    defaultImage,
    lang,
    defaultTags
  } = site.siteMetadata

  // Date of last build from graphQL
  const { buildTime } = site


  // SEO metadata from params || from default metadata
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: imagesProduct?.[0] || siteUrl + defaultImage,
    url: `${siteUrl}${pathname}`,
    tags: tags ? [...defaultTags, ...tags] : defaultTags,
  }


  // => Structured Data Object
  const StructuredDataProduct = {
    "@context": "http://schema.org",
    "@type": "Product",
    "name": title,
    "image": imagesProduct,
    "description": description,
    "weight": weight,
    "offers": {
      "@type": "Offer",
      "price": price,
      "priceCurrency": "EUR",
      "url": `${siteUrl}${pathname}`,
      "availability": `https://schema.org/${noStock ? 'OutOfStock' : 'InStock'}`,
    },
  }

  const stucturedDataSite = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    "url": siteUrl,
    "inLanguage": lang,
    "mainEntityofPage": siteUrl,
    "about": defaultDescription,
    "name": defaultTitle,
    "author": {
      "@type": "Person",
      "name": "Maillot Geoffrey",
    },
    "copyrightHolder": {
      "@type": "Person",
      "name": "Maillot Geoffrey",
    },
    "copyrightYear": '2022',
    "creator": {
      "@type": "Person",
      "name": "Maillot Geoffrey",
    },
    "publisher": {
      '@type': 'Person',
      "name": "Berthe aux pâquerettes",
    },
    "datePublished": '2022-03-07T10:30:00+01:00',
    "dateModified": buildTime,
    "image": {
      '@type': 'ImageObject',
      "url": `${siteUrl}${defaultImage}`,
    },


  }

  // => Return
  return (
    <Helmet title={seo.title} htmlAttributes={{ lang }}>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />

      {/* OG Metadata */}
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Berthes aux pâquerettes" />
      {seo.url && <meta property="og:url" content={seo.url} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {seo.image && <meta property="og:image" content={seo.image} />}
      <meta property="og:image:width" content="400" />
      <meta property="og:image:height" content="300" />
      {seo.tags.length > 0 && seo.tags.map((tag) => (
        <meta key={UUID()} property="article:tag" content={tag} />
      ))}
      {product ? <meta property="og:type" content="og:product" /> : <meta property="og:type" content="og:website" />}
      {product && price && <meta property="product:price:amount" content={price} />}

      {/* Twitter Metadata */}
      <meta name="twitter:card" content="summary_large_image" />
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {seo.image && <meta name="twitter:image" content={seo.image} />}

      {/* Structred Data*/}
      {product ?
        <script type="application/ld+json">
          {JSON.stringify(StructuredDataProduct)}
        </script>
        :
        <script type="application/ld+json">
          {JSON.stringify(stucturedDataSite)}
        </script>
      }
    </Helmet>
  )
}
export default SEO

const query = graphql`
  query SEO {
    site {
      buildTime (formatString: "YYYY-MM-DD")
      siteMetadata {
        defaultTitle: title
        defaultDescription: description
        siteUrl: siteUrl
        defaultImage: image
        lang
        defaultTags: tags
      }
    }
  }
`